// todo: implement dontBlocKdismiss which means that if a child portal is opened that doesn't mean the parent shouldn't be allowed to immediately dismiss it

import { createContext } from 'react';

// the implementation used by Select passes dontBlockDismiss in, but I'm unsure on its operation
export const ClickToDismissPortalContext = createContext({
	childPortalOpened: (id: string, dontBlockDismiss?: boolean | (() => boolean)) => undefined,
	childPortalClosed: (id: string, umount?: boolean) => undefined
});
ClickToDismissPortalContext.displayName = 'ClickToDismissContext';

export const ContainerContext = createContext<HTMLElement>(document.body);
ContainerContext.displayName = 'ContainerContext';

export const PopoverContext = createContext<{
	closePopover: (all?: boolean) => void;
	remeasure: () => void;
	getContainerRef?: () => HTMLDivElement | null;
}>({
	closePopover: () => {},
	remeasure: () => {}
});
